<template>
  <v-container grid-list-md text-xs-center v-resize="checkMobile">
    <loading :active.sync="isLoading" :is-full-page="true" color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"></loading>
    <v-card v-if="!short_client_view || show_full_fields">
      <v-card-title :class="isMobile ? 'pt-10' : ''">
        <v-row class="align-center justify-space-between">
          <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="d-flex justify-center">
            <h2 v-if="!isMobile">{{ $t("custom.add_client_2") }}</h2>
            <h3 v-else>{{ $t("custom.add_client_2") }}</h3>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6" xl="6"
            :class="!isMobile ? 'd-flex justify-end' : 'd-flex justify-center'">
            <v-switch v-model="client.entity" :label="$t('custom.company_client')" hide-details></v-switch>
            <v-switch v-model="show_full_fields" :label="$t('clients.show_full_fields')" class="ml-3"
              hide-details></v-switch>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="12" xl="12">
            <v-divider class="mb-3"></v-divider>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text v-if="!client.entity">
        <v-row>
          <v-col cols="12" sm="12" md="3">
            <v-text-field v-model.trim="client.lastname" :label="$t('bookings.lastname')" outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <v-text-field v-model.trim="client.name" :label="$t('bookings.name')" outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <v-text-field v-model.trim="client.middlename" :label="$t('bookings.middlename')" outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <phone-field ref="clientPhoneField" v-model="client.phone" mode="strict"
              :default-country="phoneDefaultCountry" :label="$t('bookings.main_phone')" outlined
              @change="checkUniqClientPhone" />
          </v-col>
          <v-col v-if="show_not_uniq_alert" cols="12" sm="12" md="12" class="mb-5">
            <v-alert type="warning" text>
              {{ $t("bookings.client_not_uniq_warning") }}
            </v-alert>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <v-text-field v-model.trim="client.email" @change="checkUniqClientEmail" :label="$t('custom.email')"
              outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <v-text-field v-model="birthday_non_format" @change="checkAge()" v-mask="'##.##.####'"
              :label="$t('bookings.birthdate')" :placeholder="$t('bookings.birthdate_plc')" outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <v-select v-if="clients_sources" v-model="client.source" :items="clients_sources"
              :label="$t('custom.source')" outlined></v-select>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <v-select v-model="client.category" :items="customer_category" item-text="text" item-value="value"
              :label="$t('bookings.client_category')" :value="$t('customer_category.new')" outlined></v-select>
          </v-col>
          <v-col cols="12" sm="12" md="2">
            <v-text-field v-model.trim="client.passport_series" :label="$t('custom.passport_series')"
              outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <v-text-field v-model.trim="client.passport_number" :label="$t('custom.passport_number')"
              outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="7">
            <v-text-field v-model.trim="client.passport_issued" :label="$t('custom.passport_issued')"
              outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field v-model="client.passport_issued_date" type="date" :label="$t('custom.passport_issued_date')"
              outlined hide-details></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field v-model="client.passport_expired_date" type="date" :label="$t('custom.passport_expired_date')"
              outlined hide-details></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field v-model.trim="client.inn" :label="$t('custom.tax_number')" outlined
              @change="checkUniqClientInn"></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <v-autocomplete v-model="client.country" flat hide-no-data hide-details :label="$t('custom.country')"
              :items="countries" item-text="both" item-value="name" outlined>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <v-text-field v-model.trim="client.city" :label="$t('custom.city')" outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <v-text-field v-model.trim="client.address" :label="$t('custom.address')" outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <v-select v-model="client.lang" :items="languages" item-text="text" item-value="value"
              :label="$t('companies.locale')" :placeholder="$t('companies.locale_plc')" outlined></v-select>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-text-field v-model.trim="client.driver_series" :label="$t('custom.license_series')"
              outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-text-field v-model.trim="client.driver_number" :label="$t('custom.license_number')"
              outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field v-model.trim="client.driver_issued" :label="$t('custom.license_issued')"
              outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field v-model="client.driver_issued_date" type="date" :label="$t('custom.driver_license_issued_date')"
              outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field v-model="client.driver_expired_date" type="date" :label="$t('custom.driver_license_expired_date')"
              outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-text-field v-model="client.taxi_license" :label="$t('custom.taxi_license')" outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-text-field v-model.trim="client.sale" :label="$t('custom.sale_perc')" outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-text-field v-model.trim="client.sale_cash" :label="$t('custom.sale_rub', { currency: currency })"
              outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-switch v-model="showDopInfo" :label="$t('other.add_client_info')"></v-switch>
          </v-col>
          <v-col cols="12" sm="12" md="12" v-if="showDopInfo">
            <v-textarea v-model="client.dop_info" clearable :label="$t('other.add_client_info_2')" rows="1"
              auto-grow></v-textarea>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row justify="center">
            <v-btn color="success" @click="submit()">{{
              $t("custom.save")
            }}</v-btn>
          </v-row>
        </v-card-actions>
      </v-card-text>
      <v-card-text v-else>
        <v-row>
          <v-col cols="12" sm="12" md="4">
            <v-text-field v-model.trim="client.entity_name" :label="$t('custom.company_name')"
              :placeholder="$t('custom.company_name_placeholder')" outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field v-model.trim="client.short_entity_name" :label="$t('custom.company_name_short')"
              :placeholder="$t('custom.company_name_short_plc')" outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field v-model.trim="client.reg_form" :label="$t('custom.reg_form')"
              :placeholder="$t('custom.reg_form_plc')" outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field v-model.trim="client.inn" :label="$t('custom.tax_number')" outlined
              @change="checkUniqClientInn"></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field v-model.trim="client.ogrn" :label="$t('custom.entity_number')" outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field v-model.trim="client.ceo" :label="$t('custom.face')" :placeholder="$t('custom.face_plc')"
              outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <phone-field ref="clientPhoneField" v-model="client.entity_phone" mode="soft"
              :default-country="phoneDefaultCountry" :label="$t('custom.entity_phone')" outlined />
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <v-text-field v-model="client.email" :label="$t('custom.email')" outlined
              @change="checkUniqClientEmail"></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <v-select v-model="client.country" :items="countries" :label="$t('custom.country')" item-text="both"
              item-value="name" outlined></v-select>
          </v-col>
          <v-col v-if="show_not_uniq_alert" cols="12" sm="12" md="12" class="mb-5">
            <v-alert type="warning" text>
              {{ $t("bookings.client_not_uniq_warning") }}
            </v-alert>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <v-text-field v-model.trim="client.city" :label="$t('custom.city')" outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-textarea v-model.trim="client.entity_adress" :label="$t('custom.entity_address_2')" outlined rows="1"
              auto-grow></v-textarea>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-textarea v-model.trim="client.address" :label="$t('custom.entity_address_3')" outlined rows="1"
              auto-grow></v-textarea>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field v-model.trim="client.acc_number" :label="$t('custom.entity_bank_number')"
              outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <v-text-field v-model.trim="client.bank" :label="$t('custom.bank_name')"
              :placeholder="$t('custom.bank_name_plc')" outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <v-text-field v-model.trim="client.korr" :label="$t('custom.bank_correspondent')" outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="2">
            <v-text-field v-model.trim="client.bik" :label="$t('custom.bank_number')" outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="2">
            <v-text-field v-model.trim="client.doc_number" :label="$t('custom.doc_number')" outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="5">
            <v-select v-model="client.source" :items="clients_sources" :label="$t('custom.source')" outlined></v-select>
          </v-col>
          <v-col cols="12" sm="12" md="5">
            <v-select v-model="client.lang" :items="languages" item-text="text" item-value="value"
              :label="$t('companies.locale')" :placeholder="$t('companies.locale_plc')" outlined></v-select>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row justify="center">
            <v-btn color="success" @click="submit()">{{
              $t("custom.save")
            }}</v-btn>
          </v-row>
        </v-card-actions>
      </v-card-text>
    </v-card>
    <v-card v-else>
      <v-card-title :class="isMobile ? 'pt-10' : ''">
        <v-row class="align-center justify-space-between">
          <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="d-flex justify-center">
            <h2 v-if="!isMobile">{{ $t("custom.add_client_2") }}</h2>
            <h3 v-else>{{ $t("custom.add_client_2") }}</h3>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6" xl="6"
            :class="!isMobile ? 'd-flex justify-end' : 'd-flex justify-center'">
            <v-switch v-model="client.entity" :label="$t('custom.company_client')" hide-details></v-switch>
            <v-switch v-model="show_full_fields" :label="$t('clients.show_full_fields')" class="ml-3"
              hide-details></v-switch>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="12" xl="12">
            <v-divider class="mb-3"></v-divider>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text v-if="!client.entity">
        <v-row>
          <v-col cols="12" sm="12" md="3">
            <v-text-field v-model="client.lastname" :label="$t('bookings.lastname')" outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <v-text-field v-model="client.name" :label="$t('bookings.name')" outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <v-text-field v-model="client.middlename" :label="$t('bookings.middlename')" outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <v-select v-if="clients_sources" v-model="client.source" :items="clients_sources"
              :label="$t('custom.source')" outlined></v-select>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <phone-field ref="clientPhoneField" v-model="client.phone" mode="strict"
              :default-country="phoneDefaultCountry" :label="$t('bookings.main_phone')" outlined
              @change="checkUniqClientPhone" />
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <v-text-field v-model="client.email" @change="checkUniqClientEmail" :label="$t('custom.email')"
              outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <v-text-field v-model="birthday_non_format" @change="checkAge()" v-mask="'##.##.####'"
              :label="$t('bookings.birthdate')" :placeholder="$t('bookings.birthdate_plc')" outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <v-select v-model="client.category" :items="customer_category" item-text="text" item-value="value"
              :label="$t('bookings.client_category')" :value="$t('customer_category.new')" outlined></v-select>
          </v-col>
          <v-col v-if="show_not_uniq_alert" cols="12" sm="12" md="12" class="mb-5">
            <v-alert type="warning" text>
              {{ $t("bookings.client_not_uniq_warning") }}
            </v-alert>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row justify="center">
            <v-btn color="success" @click="submit()">{{
              $t("custom.save")
            }}</v-btn>
          </v-row>
        </v-card-actions>
        <v-expansion-panels class="mb-3 mt-5">
          <v-expansion-panel>
            <v-expansion-panel-header>
              {{ $t("clients.extra_fields") }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="12" sm="12" md="2">
                  <v-text-field v-model="client.passport_series" :label="$t('custom.passport_series')"
                    outlined></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="3">
                  <v-text-field v-model="client.passport_number" :label="$t('custom.passport_number')"
                    outlined></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="7">
                  <v-text-field v-model="client.passport_issued" :label="$t('custom.passport_issued')"
                    outlined></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field v-model="client.passport_issued_date" type="date"
                    :label="$t('custom.passport_issued_date')" outlined hide-details></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field v-model="client.passport_expired_date" type="date"
                    :label="$t('custom.passport_expired_date')" outlined hide-details></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field v-model="client.inn" :label="$t('custom.tax_number')" outlined></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="3">
                  <v-autocomplete v-model="client.country" flat hide-no-data hide-details :label="$t('custom.country')"
                    :items="countries" item-text="both" item-value="name" outlined>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="3">
                  <v-text-field v-model="client.city" :label="$t('custom.city')" outlined></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="3">
                  <v-text-field v-model="client.address" :label="$t('custom.address')" outlined></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="3">
                  <v-select v-model="client.lang" :items="languages" item-text="text" item-value="value"
                    :label="$t('companies.locale')" :placeholder="$t('companies.locale_plc')" outlined></v-select>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field v-model="client.driver_series" :label="$t('custom.license_series')"
                    outlined></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field v-model="client.driver_number" :label="$t('custom.license_number')"
                    outlined></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field v-model="client.driver_issued" :label="$t('custom.license_issued')"
                    outlined></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field v-model="client.driver_issued_date" type="date"
                    :label="$t('custom.driver_license_issued_date')" outlined hide-details></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field v-model="client.driver_expired_date" type="date"
                    :label="$t('custom.driver_license_expired_date')" outlined hide-details></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field v-model="client.taxi_license" :label="$t('custom.taxi_license')"
                    outlined></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-textarea v-model="client.dop_info" clearable :label="$t('other.add_client_info_2')" rows="1"
                    auto-grow outlined></v-textarea>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>
              {{ $t("clients.sale_fields") }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field v-model="client.sale" :label="$t('custom.sale_perc')" outlined></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field v-model="client.sale_cash" :label="$t('custom.sale_rub', { currency: currency })"
                    outlined></v-text-field>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
      <v-card-text v-else>
        <v-row>
          <v-col cols="12" sm="12" md="4">
            <v-text-field v-model.trim="client.entity_name" :label="$t('custom.company_name')"
              :placeholder="$t('custom.company_name_placeholder')" outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field v-model.trim="client.short_entity_name" :label="$t('custom.company_name_short')"
              :placeholder="$t('custom.company_name_short_plc')" outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field v-model.trim="client.reg_form" :label="$t('custom.reg_form')"
              :placeholder="$t('custom.reg_form_plc')" outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field v-model.trim="client.inn" :label="$t('custom.tax_number')" outlined
              @change="checkUniqClientInn"></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field v-model.trim="client.ogrn" :label="$t('custom.entity_number')" outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field v-model.trim="client.ceo" :label="$t('custom.face')" :placeholder="$t('custom.face_plc')"
              outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <phone-field ref="clientPhoneField" v-model="client.entity_phone" mode="soft"
              :default-country="phoneDefaultCountry" :label="$t('custom.entity_phone')" outlined />
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <v-text-field v-model="client.email" @change="checkUniqClientEmail" :label="$t('custom.email')"
              outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <v-select v-model="client.country" :items="countries" :label="$t('custom.country')" item-text="both"
              item-value="name" outlined></v-select>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <v-text-field v-model.trim="client.city" :label="$t('custom.city')" outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-textarea v-model.trim="client.entity_adress" :label="$t('custom.entity_address_2')" outlined rows="1"
              auto-grow></v-textarea>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-textarea v-model.trim="client.address" :label="$t('custom.entity_address_3')" outlined rows="1"
              auto-grow></v-textarea>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field v-model.trim="client.acc_number" :label="$t('custom.entity_bank_number')"
              outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <v-text-field v-model.trim="client.bank" :label="$t('custom.bank_name')"
              :placeholder="$t('custom.bank_name_plc')" outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <v-text-field v-model.trim="client.korr" :label="$t('custom.bank_correspondent')" outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="2">
            <v-text-field v-model.trim="client.bik" :label="$t('custom.bank_number')" outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="2">
            <v-text-field v-model.trim="client.doc_number" :label="$t('custom.doc_number')" outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="5">
            <v-select v-model="client.source" :items="clients_sources" :label="$t('custom.source')" outlined></v-select>
          </v-col>
          <v-col cols="12" sm="12" md="5">
            <v-select v-model="client.lang" :items="languages" item-text="text" item-value="value"
              :label="$t('companies.locale')" :placeholder="$t('companies.locale_plc')" outlined></v-select>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row justify="center">
            <v-btn color="success" @click="submit()">{{
              $t("custom.save")
            }}</v-btn>
          </v-row>
        </v-card-actions>
      </v-card-text>
      <v-card-text v-if="clients && clients.length > 0">
        <v-divider></v-divider>
        <v-subheader>{{ $t("custom.finded_clients") }}</v-subheader>
        <v-list-item v-for="finded_client in clients" :key="finded_client.id">
          <v-list-item-content>
            <v-list-item-title>{{ clientFullName(finded_client) }} {{
              formatPhone(finded_client.phone) }} {{ finded_client.email }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { clientFullName } from "@/utils/personName";
import { countries } from "./../countries";
import moment from "moment";
import { setMomentLocale } from "@/utils/localeInfra";
import PhoneField from "@/components/common/PhoneField.vue";
import { defaultPhoneCountry } from "@/lib/phone/defaultCountry";
import { formatPhone } from "@/lib/phone/display";
import { phoneFieldsAreValid } from "@/lib/phone/fieldValidation";
import "moment/locale/ru";
import "moment/locale/en-gb";
// moment.locale("ru");
export default {
  data() {
    return {
      client: {
        name: "",
        lastname: "",
        middlename: "",
        phone: "",
        country: null,
        city: "",
        address: "",
        sale: 0,
        sale_cash: 0,
        passport: "",
        driver: "",
        birthday: null,
        category: "Новый",
        email: null,
      },
      clients: [],
      customer_category: [
        { text: this.$t("customer_category.new"), value: "Новый" },
        { text: this.$t("customer_category.loyal"), value: "Лояльный" },
        { text: this.$t("customer_category.statement"), value: "Постоянный" },
        { text: this.$t("customer_category.problem"), value: "Серый" },
        { text: this.$t("customer_category.bad"), value: "Чёрный" },
      ],
      languages: [
        { text: this.$t("companies.default_lang"), value: null },
        { text: "English", value: "en" },
        { text: "Русский", value: "ru" },
        { text: "Português (Portugal)", value: "pt" },
        { text: "Português (Brasil)", value: "pt-BR" },
        { text: "Српски", value: "sr" },
        { text: "Thai", value: "th" },
        { text: "Ελληνικά", value: "el" },
        { text: "Hrvatski", value: "hr" },
        { text: "Turkish", value: "tr" },
        { text: "French", value: "fr" },
        { text: "German", value: "de" },
        { text: "Spanish", value: "es" },
        { text: "Italian", value: "it" },
        { text: "Indonesian", value: "id" },
        { text: "Polski", value: "pl" },
        { text: "Română", value: "ro" },
      ],
      age_limit: 26,
      showDopInfo: false,
      countries: this.$i18n.locale == "ru" ? countries : countries.sort((a, b) => {
        if (a.native < b.native) {
          return -1;
        }
        if (a.native > b.native) {
          return 1;
        }
        return 0;
      }),
      coloredDate: false,
      birthday_non_format: null,
      show_full_fields: false,
      show_not_uniq_alert: false,
      timeout: null,
      uniqCheckRequestId: 0,
      isMobile: false,
      isLoading: false,
      error: "",
    };
  },
  created() {
    let self = this;
    // moment Locale
    setMomentLocale(this.$i18n.locale);
    if (this.$store.getters.isLoggedIn) {
      this.age_limit = this.$store.getters.getCompany.company.age_limit;
    } else {
      this.$store.commit("unsetCurrentUser");
    }
  },
  watch: {
    birthday_non_format: function (val) {
      if (val && val.length == 10) {
        this.client.birthday = moment(val, "DD.MM.YYYY").format("YYYY-MM-DD");
      }
    },
  },
  computed: {
    clients_sources() {
      if (this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.clients_sources) {
        return this.$store.getters.getCompany.company.clients_sources;
      } else {
        return [];
      }
    },
    currency() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.currency
      ) {
        return this.$store.getters.getCompany.company.currency;
      } else {
        return "";
      }
    },
    short_client_view() {
      return this.$store.getters.getUserSettings.short_client_view;
    },
    main_company() {
      return this.$store.getters.getMainCompany;
    },
    company() {
      return this.$store.getters.getCompany.company;
    },
    phoneDefaultCountry() {
      return defaultPhoneCountry({ client: this.client, company: this.company });
    },
    isTaxiMode() {
      return this.company && this.company.taxi_park_type && this.company.taxi_park_type !== 'not_taxi';
    },
  },
  methods: {
    formatPhone,
    clientFullName,
    generateFio(name, middlename, lastname, isEntity) {
      // Для юридических лиц возвращаем полное имя
      if (isEntity) {
        return name;
      }

      // Функция для сокращения имени/отчества (берет первую букву каждого слова)
      const abbreviate = (str) => {
        if (!str) return "";
        return str
          .split(/\s+/)
          .filter(word => word.length > 0)
          .map(word => word[0].toUpperCase() + ".")
          .join(" ");
      };

      // Сокращаем имя и отчество, фамилия уже капитализирована в submit
      const nameAbbr = abbreviate(name);
      const middlenameAbbr = middlename ? abbreviate(middlename) : "";

      // Формируем FIO
      if (middlenameAbbr) {
        return `${nameAbbr} ${middlenameAbbr} ${lastname}`;
      } else {
        return `${nameAbbr} ${lastname}`;
      }
    },
    checkAge() {
      if (this.client.birthday) {
        console.log(this.client.birthday, "this.client.birthday")
        let startDate = moment(this.client.birthday, ["DD.MM.YYYY", "YYYY-MM-DD"]);
        let endDate = moment();
        let duration = moment.duration(endDate.diff(startDate));
        let years = duration.asYears();

        if (years < this.age_limit) {
          this.$notify(this.$t("bookings.low_age_title"), this.$t("bookings.low_age_text", { years: parseInt(years) }), "warning", 5000);
        }
      }
    },
    validateEmail(email) {
      if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        this.$notify(this.$t("errors.add_client_title"), this.$t("errors.bad_email_2"), "warning", 5000);
      }
    },
    checkUniqClient(search, key = "search") {
      let self = this;
      const requestId = (self.uniqCheckRequestId || 0) + 1;
      self.uniqCheckRequestId = requestId;
      function debounce() {
        if (self.timeout) clearTimeout(self.timeout);

        self.timeout = setTimeout(() => {
          // your action
          self.show_not_uniq_alert = false;
          self.axios.post(`/api/v1/check_client_uniqueness`,
            { [key]: search },
            {
              headers: {
                Authorization: self.$store.getters.getAuthToken,
              },
            }).then((response) => {
              if (requestId !== self.uniqCheckRequestId) return;
              self.clients = response.data;
              if (self.clients.length > 0) {
                self.show_not_uniq_alert = true;
              } else {
                self.show_not_uniq_alert = false;
              }
            });
        }, 300); // delay
      }
      debounce();
    },
    checkUniqClientPhone() {
      if (this.client.phone && String(this.client.phone).trim().length > 5) {
        this.checkUniqClient(this.client.phone, "phone");
      } else {
        this.uniqCheckRequestId = (this.uniqCheckRequestId || 0) + 1;
        if (this.timeout) clearTimeout(this.timeout);
        this.show_not_uniq_alert = false;
      }
    },
    checkUniqClientInn() {
      if (this.client.inn && this.client.inn.length > 4) {
        this.checkUniqClient(this.client.inn.replace(' ', ''));
      } else {
        this.show_not_uniq_alert = false;
      }
    },
    checkUniqClientEmail() {
      if (this.client.email && this.client.email.length > 3) {
        if (
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
            this.client.email
          )
        ) {
          this.checkUniqClient(this.client.email);
        } else {
          this.$notify(this.$t("errors.bad_email_2"), this.$t("errors.bad_email_desc"), "warning", 5000);
        }
      } else {
        this.show_not_uniq_alert = false;
      }
    },
    submit() {
      // проверяем на должника
      if (this.$store.getters.getMainCompany && this.$store.getters.getMainCompany.payer_state == 3) {
        this.$notify(this.$t("errors.payer_state_3_title"), this.$t("errors.payer_state_3_text"), "warning", 10000);
        return;
      }
      if (!phoneFieldsAreValid(this.$refs && this.$refs.clientPhoneField)) return;
      if (this.isStaff) {
        this.isLoading = true;
        let self = this;
        let client = this.client;
        let middlename, year, birthday;

        if (client.middlename) {
          middlename = this.capitalizeWords(client.middlename.trim());
        } else {
          middlename = "";
        }

        if (client.birthday) {
          console.log(client.birthday);
          birthday = client.birthday;

          year = birthday.split("-")[0];
        }
        if ((client.name && client.lastname) || client.entity) {
          this.newClientDialog = false;
          this.showClients = false;

          let name = client.name ? this.capitalizeWords(client.name.trim()) : "";
          let lastname = client.lastname
            ? this.capitalizeWords(client.lastname.trim())
            : "";

          this.axios
            .post(
              "/api/v1/clients",
              {
                clients: {
                  name: name,
                  lastname: lastname,
                  middlename: middlename,
                  fio: this.generateFio(name, middlename, lastname, client.entity),
                  email: client.email,
                  phone: client.phone,
                  country: client.country,
                  city: client.city,
                  address: client.address,
                  sale: client.sale,
                  sale_cash: client.sale_cash,
                  passport_series: client.passport_series,
                  passport_number: client.passport_number,
                  passport_issued: client.passport_issued,
                  passport_issued_date: client.passport_issued_date,
                  passport_expired_date: client.passport_expired_date,
                  driver_series: client.driver_series,
                  driver_number: client.driver_number,
                  driver_issued: client.driver_issued,
                  driver_issued_date: client.driver_issued_date,
                  driver_expired_date: client.driver_expired_date,
                  birthday: client.birthday ? client.birthday : null,
                  year: year,
                  category: client.category,
                  dop_info: client.dop_info,
                  entity: client.entity,
                  entity_name: client.entity_name,
                  short_entity_name: client.short_entity_name,
                  ceo: client.ceo,
                  reg_form: client.reg_form,
                  entity_phone: client.entity_phone,
                  entity_adress: client.entity_adress,
                  inn: client.inn,
                  ogrn: client.ogrn,
                  acc_number: client.acc_number,
                  bank: client.bank,
                  korr: client.korr,
                  bik: client.bik,
                  doc_number: client.doc_number,
                  source: client.source,
                  taxi_license: client.taxi_license,
                  lang: client.lang,
                },
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then((response) => {
              this.$router.replace(`/clients/${response.data.id}`);

              this.$notify(this.$t("custom.add_client_title"), this.$t("custom.add_client_text"), "success");
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.add_client_title"));
            })
            .finally(() => (this.isLoading = false));
        } else {
          this.$notify(this.$t("errors.all_fields_title"), this.error, "error");
          this.isLoading = false;
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    capitalizeFirst(text) {
      return text[0].toUpperCase() + text.substring(1).toLowerCase();
    },
    capitalizeWords(text) {
      if (!text) return "";
      return text
        .split(/\s+/)
        .filter(word => word.length > 0)
        .map(word => word[0].toUpperCase() + word.substring(1).toLowerCase())
        .join(" ");
    },
    FormattedMomentjs() {
      // console.log(this.birthday_non_format, moment(this.birthday_non_format, "YYYY-MM-DD").format('DD-MM-YYYY'))
      return (this.client.birthday = moment(
        this.birthday_non_format,
        "YYYY-MM-DD"
      ).format("DD-MM-YYYY"));
    },
    currentUser() {
      return this.$store.getters.getCurrentUser;
    },
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    },
  },
  components: {
    PhoneField,
  },
};
</script>
